import { NavLink as NavigationLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { mediaQuery } from '../../../../styles/mixin';

export const NavLink = styled(NavigationLink)`
    color: white;
    background: transparent;
    width: 100%;
    display: flex;
    font-size: ${({ theme }) => theme.fontSizes[5]};
    padding: 1em 1.6em;
    border-radius: 0.5em;
    user-select: none;
    transition: all ${({ theme }) => theme.transitions.hover};

    &.active {
        color: ${({ theme }) => theme.colors.fontPrimary};
        background: white;
    }

    &:hover:not(.active) {
        color: ${({ theme }) => theme.colors.logoPrimary};
    }

    ${mediaQuery(
        3,
        css`
            padding: 1em 2em;
        `
    )}
`;
